import { useState, useContext } from "react";
import { UserInfo } from "../helper/Context.js";
import { useLocation, useNavigate } from "react-router-dom";
import DoiRequestModal from "../components/DoiRequestModal.js";

const DoiRequestPage = () => {
  const { userInfo } = useContext(UserInfo);
  const location = useLocation();
  const navigate = useNavigate();
  const visualUrl = location.state?.visualUrl || "";
  
  const [showModal, setShowModal] = useState(true);

  const handleHide = () => {
    setShowModal(false);
    navigate(-1);
  };

  return (
    <DoiRequestModal 
      show={showModal} 
      onHide={handleHide} 
      visualUrl={visualUrl} 
    />
  );
};

export default DoiRequestPage;
